import type { GetSanAdAccountZeitStatusAction } from '../../../actions/getSANAdPartnerZeitStatus';
import type { GetGoogleAuthenticationUrlAction } from '../../actions/getAuthenticationUrl.action';
import type { GetGoogleMarketingAdAccountsAction } from './getAdAccounts.action';

export * from '../../actions/getAuthenticationUrl.action';
export * from './getAdAccounts.action';

export type GoogleAction =
  | GetGoogleAuthenticationUrlAction
  | GetGoogleMarketingAdAccountsAction
  | GetSanAdAccountZeitStatusAction;
